import { addEventListener, clampScope, inRange, lerp, Raf, scoped, vevet } from 'vevet';
import { isMobile } from './isMobile';
import { VINYL_CAROUSEL_SETTINGS } from './settings';
const settings = VINYL_CAROUSEL_SETTINGS;

const defaultSpeed = settings.mouseSpeedZones[1].factor;
export class MouseMarquee {
	constructor(_container, _onRender) {
		Object.defineProperty(this, '_container', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: _container,
		});
		Object.defineProperty(this, '_onRender', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: _onRender,
		});
		Object.defineProperty(this, '_raf', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0,
		});
		Object.defineProperty(this, '_speed', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: {
				current: 0,
				target: defaultSpeed,
			},
		});
		Object.defineProperty(this, '_listener', {
			enumerable: true,
			configurable: true,
			writable: true,
			value: void 0,
		});
		this._raf = new Raf({ enabled: false });
		this._raf.on('frame', this._render.bind(this));
		this._listeners = [];
		this._listeners.push(addEventListener(_container, 'mousemove', this._handleMouseMove.bind(this)));

		this._listeners.push(addEventListener(_container, 'mouseleave', this._handleMouseLeave.bind(this)));
	}
	destroy() {
		this._raf?.destroy();
		this._listeners.forEach((listener) => listener());
	}

	isEnabled() {
		if (vevet.mobile || isMobile() || !this._raf.props.enabled) {
			return false;
		}

		return true;
	}
	_handleMouseMove(evt) {
		if (!this.isEnabled()) {
			return;
		}
		const bounding = this._container.getBoundingClientRect();
		const yPosition = evt.clientY - bounding.top;
		const yProgress = scoped(yPosition, bounding.height / 2, bounding.height);
		const zoneIndex = settings.mouseSpeedZones.findIndex((zone) =>
			inRange(Math.abs(yProgress), zone.scope[0], zone.scope[1]),
		);
		const zone = zoneIndex === -1 ? undefined : settings.mouseSpeedZones[zoneIndex];
		if (!zone) {
			return;
		}
		const prevZone = zoneIndex === 0 ? undefined : settings.mouseSpeedZones[zoneIndex - 1];
		const prevFactor = prevZone ? prevZone.factor : zone.factor;
		const zoneProgress = clampScope(Math.abs(yProgress), zone.scope);
		const factor = prevFactor + (zone.factor - prevFactor) * zoneProgress;
		const speed = factor * Math.sign(yProgress);
		this._speed.target = speed;
	}

	_handleMouseLeave(evt) {
		if (!this.isEnabled()) {
			return;
		}

		const bounding = this._container.getBoundingClientRect();
		const yPosition = evt.clientY - bounding.top;
		const yProgress = scoped(yPosition, bounding.height / 2, bounding.height);
		const dir = Math.sign(yProgress);

		this._speed.target = defaultSpeed * dir;
	}
	enable() {
		this._raf.updateProps({ enabled: true });
	}
	disable() {
		this._raf.updateProps({ enabled: false });
	}
	_render() {
		const speed = this._speed;
		const ease = this._raf.lerpFactor(0.2);
		speed.current = lerp(speed.current, speed.target, ease);
		this._onRender();
	}

	get value() {
		return this._speed.current;
	}
}
